import angular from "angular";
import EditCostGroupMembershipPreset from "./dialogs/editCostGroupMembership/edit_cost_group_membership.config";
import sbCommercialMembershipEdit from "./components/sbCommercialMembershipEdit/commercial_membership_edit.component";
import "angular-material";

export default angular
    .module("sbApp.commercial", [
        "ngMaterial",
        "ui.router",
        "sbApp.services",
        "sbApp.directives",
        "sbApp.common.components.processTemplate",
    ])
    .component(sbCommercialMembershipEdit.name, sbCommercialMembershipEdit)
    .config(EditCostGroupMembershipPreset);
